import { render, staticRenderFns } from "./OffersList.vue?vue&type=template&id=1c7f4857&"
import script from "./OffersList.vue?vue&type=script&lang=ts&"
export * from "./OffersList.vue?vue&type=script&lang=ts&"
import style0 from "./OffersList.vue?vue&type=style&index=0&id=1c7f4857&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports